import { useState } from 'react';
import ReactDOM from 'react-dom';
import { Popup } from 'semantic-ui-react';
import { AchievementGuestData } from '../types';
import { AchievementPopup } from '../../achievements/AchievementPopup';
import styles from './styles.module.scss';
import { getAchCategory } from '../../achievements/utils';

export const Achievement = ({
  isActive,
  achievement,
  withPopup = false
}: {
  isActive: boolean,
  achievement: AchievementGuestData,
  withPopup?: boolean
}) => {
  const [isPopupVisible, setIsPopupVisible] = useState(false);

  const handleAchievementClick = () => {
    setIsPopupVisible(true);
  };

  const handleClosePopup = () => {
    setIsPopupVisible(false);
  };

  return (
    <>
      {
        withPopup && isPopupVisible && (
          ReactDOM.createPortal(
            <AchievementPopup onClose={handleClosePopup} achData={achievement} inProfile={false} />,
            document.getElementById('popup-achievement')!
          )
        )
      }
      <div
        className={`${styles.Achievement} ${withPopup && styles.HoverableAch}`}
      >
        <img
          className={!isActive ? styles.unactiveImg : ""}
          src={`/static/images/achievements/${getAchCategory(achievement.type)}/${achievement.type}.png`}
          alt={achievement.name}
          onClick={handleAchievementClick}
        />

        <div className={styles.Achievement_info}>
          <div className={styles.Achievement_info__name}>
            <h3>{achievement.name}</h3>
            {
              !!achievement.fullDescription.length &&
              <Popup
                flowing
                hoverable
                className={styles.Popups}
                inverted
                basic
                style={{ backgroundColor: "#333333" }}
                mouseLeaveDelay={500}
                position={"top center"}
                trigger={
                  <img src="/static/images/achievements/info_icon.svg" alt="" />
                }
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: achievement.fullDescription,
                  }} />
              </Popup>
            }
          </div>
          {
            !withPopup &&
            <div
              className={styles.Achievement_info__info}
              dangerouslySetInnerHTML={{
                __html: achievement.shortDescription,
              }}
            />
          }
        </div>
      </div>
    </>
  );
};
